import { connect } from 'react-redux';

import decorate from '../../utils/decorate';

import { request as open } from '../../modules/customers/actions/open';
import { request as getFreeBetCredits } from '../../modules/customers/actions/get-freebet-credits';
import { request as close } from '../../modules/customers/actions/close';
import { request as saveHistory } from '../../modules/customers/actions/save-history';

import CustomersBar from './CustomersBar.jsx';

function mapStateToProps(state) {
    return {
        opened: state.customers.get('opened'),
        customers: state.customers.get('list'),
        history: state.customers.get('history'),
        universe: state.user.getIn(['data', 'universe'])
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onOpenRequest: (id, name, parameters) => dispatch(open(id, name, parameters)),
        getCustomerFreeCredits: (id) => dispatch(getFreeBetCredits(id)),
        onCloseRequest: (id) => dispatch(close(id)),
        onSaveHistoryRequest: (id, data) => dispatch(saveHistory(id, data))
    };
}

// eslint-disable-next-line import/no-default-export
export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    CustomersBar
);

